import { executeRequest, Request } from '@jfs/network'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const reAuthSession = (tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: 'user/auth/regenerate',
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { reAuthSession }
